export interface MissionControlCandidate {
  siteId: string;
  label: string;
}

const SITE_ID = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,191}$/;

/** Directory IDs are suggestions, never an automatic grant or verified mapping. */
export function missionControlCandidates(directory: {
  name?: string | null;
  mission_control_site_id?: string | null;
  additional_networks?: unknown;
} | null): MissionControlCandidate[] {
  if (!directory) return [];
  const result = new Map<string, MissionControlCandidate>();
  const add = (siteId: unknown, label: unknown) => {
    if (typeof siteId !== 'string' || !SITE_ID.test(siteId) || result.has(siteId)) return;
    result.set(siteId, {
      siteId,
      label: (typeof label === 'string' && label.trim() ? label.trim() : 'Site network').slice(0, 160),
    });
  };
  add(directory.mission_control_site_id, directory.name);
  if (Array.isArray(directory.additional_networks)) {
    for (const network of directory.additional_networks) {
      if (network && typeof network === 'object') {
        add(network.mission_control_site_id, network.name);
      }
    }
  }
  return [...result.values()];
}

export function missionControlLinkError(error: { code?: string; message?: string }): string {
  if (error.code === '23505') return 'This Mission Control network already has an active site link. Check the existing link before continuing.';
  if (error.code === 'PT409' || error.code === '40001') return 'Someone changed this site link. Reload and review the current version.';
  if (error.code === '42501') return 'Your current account cannot change site links. Sign in again or contact an administrator.';
  return 'The site link could not be saved. Check the site ID, label and reason, then try again.';
}
